module.exports = __webpack_public_path__ + "static/media/a2_parking.7cd73805.png";